<div class="tasks-page" [attr.dir]="dir">
  
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="fa-solid fa-tasks"></i>
        {{ 'Tasks' | navTitle | async }}
      </h1>
      <div class="strategy-selector">
        <p-dropdown 
          (onChange)="strategyOptionsChange()" 
          [(ngModel)]="selectedStrategyId"
          [options]="strategyOptions" 
          optionLabel="name" 
          optionValue="strategyId" 
          [placeholder]="dir === 'rtl' ? 'اختر استراتيجية' : 'Select Strategy'">
        </p-dropdown>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tasks-content">
    <p-tabView [(activeIndex)]="activeIndex" styleClass="tasks-tabs">
      
      <!-- Projects Tab -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="tab-header">
            <i class="fa-solid fa-rocket"></i>
            <span>{{ dir === 'rtl' ? 'المبادرات' : 'Projects' }}</span>
            <span class="tab-badge">{{total_no_of_projects}}</span>
        </div>
        </ng-template>

        <div class="tab-content">
                        @if(projects.length){
            <!-- Period Filter -->
            <div class="filter-section">
              <label class="filter-label">
                <i class="fa-solid fa-calendar-days"></i>
                {{ dir === 'rtl' ? 'الفترة' : 'Period' }}
              </label>
              <p-dropdown 
                (onChange)="periodChange()" 
                [options]="periodOptions"
                [(ngModel)]="selectedPeriodOption" 
                optionLabel="label" 
                optionValue="value"
                [placeholder]="dir === 'rtl' ? 'اختر الفترة' : 'Select Period'">
              </p-dropdown>
                            </div>

            <!-- Projects Table -->
            <div class="projects-table-wrapper">
              <p-table 
                #table 
                [scrollable]="true" 
                [paginator]="true" 
                [rows]="5"
                [rowsPerPageOptions]="[5, 10, 20]" 
                [class]="dir" 
                [value]="projects" 
                dataKey="id"
                (onRowExpand)="onRowExpand($event)"
                (onRowCollapse)="onRowCollapse($event)"
                styleClass="modern-table">

                                <ng-template pTemplate="header">
                                    <tr>
                    <th style="width: 3rem"></th>
                    <th [class]="dir=='rtl'?'text-right':'text-left'">
                      <i class="fa-solid fa-clipboard-list"></i>
                      {{'name'|translate}}
                    </th>
                    <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-project let-expanded="expanded">
                  <tr class="project-row" [class.expanded]="expanded">
                    <td>
                      <p-button 
                        type="button" 
                        pRipple 
                        [pRowToggler]="project" 
                        [text]="true"
                        [rounded]="true" 
                        [plain]="true"
                                                [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                                        </td>
                    <td [class]="dir=='rtl'?'text-right':'text-left'" class="project-name" [pTooltip]="project.name" tooltipPosition="top">
                      <i class="fa-solid fa-rocket project-icon"></i>
                      <span class="project-name-text">{{ project.name }}</span>
                    </td>
                                        <td>
                                            <a [routerLink]="['/strategies',selectedStrategyId,'projects',project.id]">
                        <p-button 
                          [pTooltip]="dir === 'rtl' ? 'الذهاب إلى المبادرة' : 'Go to Project'"
                          severity="success"
                          [outlined]="true">
                                                    @if(dir=='rtl'){
                            <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                                                    }@else{
                                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                                    }
                                                </p-button>
                                            </a>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="rowexpansion" let-project>
                                    <tr>
                    <td colspan="3">
                      <div class="milestones-section">
                        <h4 class="milestones-title">
                          <i class="fa-solid fa-list-check"></i>
                          {{ dir === 'rtl' ? 'مراحل التنفيذ' : 'Milestones' }}
                        </h4>
                        <p-table [value]="monthly?project.month:project.week" dataKey="id" styleClass="milestones-table">
                                                    <ng-template pTemplate="header">
                                    <tr>
                              <th>{{'name'|translate}}</th>
                              <th>{{'description'|translate}}</th>
                              <th>{{'outputs'|translate}}</th>
                              <th>{{'implementation_period' | translate}}</th>
                              <th>{{ dir === 'rtl' ? 'مؤشر أداء المرحلة' : 'Milestone KPI' }}</th>
                              <th>{{ dir === 'rtl' ? 'حالة المرحلة' : 'Status' }}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-mileStone>
                                    <tr>
                              <td class="milestone-name">
                                <i class="fa-solid fa-circle-dot milestone-dot"></i>
                                            {{mileStone.name}}
                                        </td>
                              <td>{{mileStone.description}}</td>
                              <td>{{mileStone.outputs}}</td>
                              <td class="period-cell">
                                <div class="date-row">
                                  <i class="fa-solid fa-calendar-plus"></i>
                                  <span class="date-label">{{ dir === 'rtl' ? 'من:' : 'From:' }}</span> 
                                  <span class="date-value">{{mileStone.start_date|date}}</span>
                                            </div>
                                <div class="date-row">
                                  <i class="fa-solid fa-calendar-check"></i>
                                  <span class="date-label">{{ dir === 'rtl' ? 'إلى:' : 'To:' }}</span> 
                                  <span class="date-value">{{mileStone.end_date|date}}</span>
                                            </div>
                                        </td>
                              <td>{{mileStone.indicator_name}}</td>
                                        <td>
                                            @if(mileStone.is_done){
                                  <p-tag severity="success" [value]="dir === 'rtl' ? 'نفذت' : 'Completed'" />
                                            }
                                            @else if(mileStone.is_done == null){
                                  <p-tag severity="secondary" [value]="dir === 'rtl' ? 'لم تحدد بعد' : 'Not Set'" />
                                            }
                                            @else if(!mileStone.is_allowed_to_upload){
                                  <p-tag severity="info" [value]="dir === 'rtl' ? 'قيد المراجعة' : 'Under Review'" />
                                            }
                                            @else{
                                  <p-tag severity="warning" [value]="dir === 'rtl' ? 'قيد التنفيذ' : 'In Progress'" />
                                            }
                                        </td>
                                    </tr>
                                </ng-template>
                          <ng-template pTemplate="emptymessage">
                                    <tr>
                              <td class="empty-message" colspan="6">
                                            <i class="fa-solid fa-circle-exclamation"></i>
                                            {{'no_data_found' | translate}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        </td>
                        </tr>
                        </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="3">
                      <div class="empty-state">
                        <i class="fa-solid fa-inbox"></i>
                        <p>{{total_no_of_projects == 0 ? 'no_initiatives_assigned_to_you' : 'no_required_milestones_this_month' |translate}}</p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                        </p-table>
                    </div>
                    }@else{
            <div class="empty-state">
              <i class="fa-solid fa-inbox"></i>
              <p>{{total_no_of_projects == 0 ? 'no_initiatives_assigned_to_you' : 'no_required_milestones_this_month' |translate}}</p>
                    </div>
                    }
        </div>
        </p-tabPanel>

      <!-- Indicators Tab -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="tab-header">
            <i class="fa-solid fa-chart-line"></i>
            <span>{{ dir === 'rtl' ? 'المؤشرات' : 'Indicators' }}</span>
            <span class="tab-badge">{{total_no_of_indicators}}</span>
          </div>
        </ng-template>

        <div class="tab-content">
                @if(indicators.length){
            <!-- Indicators Table -->
            <div class="indicators-table-wrapper">
              <p-table 
                #dt 
                [paginator]="true" 
                [rows]="5" 
                [rowsPerPageOptions]="[5, 10, 20]" 
                [class]="dir"
                [value]="indicators" 
                dataKey="id"
                (onRowExpand)="onRowExpand($event)" 
                (onRowCollapse)="onRowCollapse($event)"
                styleClass="modern-table">

                        <ng-template pTemplate="header">
                            <tr>
                    <th style="width: 3rem"></th>
                    <th [class]="dir=='rtl'?'text-right':'text-left'">
                      <i class="fa-solid fa-chart-simple"></i>
                      {{'name'|translate}}
                    </th>
                    <th style="width: 4rem"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-indicator let-expanded="expanded">
                  <tr class="indicator-row" [class.expanded]="expanded">
                    <td>
                      <p-button 
                        type="button" 
                        pRipple 
                        [pRowToggler]="indicator" 
                        [text]="true"
                        [rounded]="true" 
                        [plain]="true"
                                        [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                                </td>
                    <td [class]="dir=='rtl'?'text-right':'text-left'" class="indicator-name" [pTooltip]="indicator.name" tooltipPosition="top">
                      <i class="fa-solid fa-chart-line indicator-icon"></i>
                      <span class="indicator-name-text">{{ indicator.name }}</span>
                    </td>
                                <td>
                                    <a [routerLink]="['/strategies',selectedStrategyId,'indicators',indicator.id]">
                        <p-button 
                          [pTooltip]="dir === 'rtl' ? 'الذهاب إلى المؤشر' : 'Go to Indicator'"
                          severity="success"
                          [outlined]="true">
                                            @if(dir=='rtl'){
                                            <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                                            }@else{
                                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                            }
                                        </p-button>
                                    </a>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="rowexpansion" let-indicator>
                            <tr>
                    <td colspan="3">
                      <div class="outcomes-section">
                        <h4 class="outcomes-title">
                          <i class="fa-solid fa-bullseye"></i>
                          {{ dir === 'rtl' ? 'النتائج الدورية' : 'Periodic Outcomes' }}
                        </h4>
                        <p-table [value]="monthly?indicator.month:indicator.week" dataKey="id" styleClass="outcomes-table">
                                            <ng-template pTemplate="header">
                            <tr>
                              <th>{{'kpi_cycle'|translate}}</th>
                              <th>{{'implementation_period' | translate}}</th>
                              <th>{{'target'|translate}}</th>
                              <th>{{'actual'|translate}}</th>
                            </tr>
                        </ng-template>
                          <ng-template pTemplate="body" let-outcome>
                            <tr>
                                <td>
                                <span class="cycle-badge">{{outcome.cycle}}</span>
                                </td>
                              <td class="period-cell">
                                <div class="date-row">
                                  <i class="fa-solid fa-calendar-plus"></i>
                                  <span class="date-label">{{ dir === 'rtl' ? 'من:' : 'From:' }}</span>
                                  <span class="date-value">{{outcome.start_read_date|date}}</span>
                                    </div>
                                <div class="date-row">
                                  <i class="fa-solid fa-calendar-check"></i>
                                  <span class="date-label">{{ dir === 'rtl' ? 'إلى:' : 'To:' }}</span>
                                  <span class="date-value">{{outcome.positive_entry_date|date}}</span>
                                    </div>
                                </td>
                              <td class="target-value">{{outcome.target}}</td>
                              <td class="actual-value">{{outcome.actual}}</td>
                            </tr>
                        </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td class="empty-message" colspan="4">
                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    {{'no_data_found' | translate}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                </td>
                </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="3">
                      <div class="empty-state">
                        <i class="fa-solid fa-inbox"></i>
                        <p>{{total_no_of_indicators == 0 ? 'no_indicators_assigned_to_you' : 'no_periodic_targets_this_month' |translate}}</p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                </p-table>
            </div>
            }@else{
            <div class="empty-state">
              <i class="fa-solid fa-inbox"></i>
              <p>{{total_no_of_indicators == 0 ? 'no_indicators_assigned_to_you' : 'no_periodic_targets_this_month' |translate}}</p>
            </div>
            }
    </div>
    </p-tabPanel>
    </p-tabView>
</div>

</div>
